<template>
  <v-row no-gutters>
    <v-col>
      <card-title-row class="pl-0 pt-5" translation-path="sidebar.attributesPainter.title">
        <template #subtitle>
          <italic-subheader
            style="font-size: 12px !important;"
            class="text-left"
            translation-path="sidebar.attributesPainter.featuresSubtitle"
          />
        </template>
      </card-title-row>
      <sidebar-row>
        <v-row no-gutters class="pt-5 pb-3">
          <v-col cols="auto" class="text-left" style="font-weight: 400; font-size: 14px">
            {{ $i18n.t('sidebar.attributesPainter.selectObjectToCopy') }}:
          </v-col>
        </v-row>
        <v-list v-if="hasAnyFeatures" class="py-0">
          <template v-for="(feature, idx) in attributesPainterObjects">
            <!-- Disable hover for now, cuz of table highlighting problems -->
            <!-- @mouseleave="onHover(feature, false)" @mouseenter="onHover(feature, true)" -->
            <v-list-item :key="idx" @click="openAttributesPainter(feature)">
              <v-list-item-content class="pa-0">
                <v-list-item-title>
                  <v-subheader class="pl-0 font--text text-body-2" style="height: auto;">
                    {{ feature.name }}: {{ feature.number || feature.descAttributeValue }}
                  </v-subheader>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action @click.stop="zoomToFeature(feature.id, feature.layerId)">
                <v-icon color="rgba(0,0,0,.7)" size="19px">mdi-magnify</v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
        <template v-else>
          <v-subheader style="height: auto;" class="text-body-2">
            {{ $i18n.t('sidebar.noIdentifiedObjects') }}
          </v-subheader>
        </template>
      </sidebar-row>
    </v-col>
  </v-row>
</template>
<script>
import { get, sync } from 'vuex-pathify';

import CardTitleRow from '@/components/CardTitleRow';
import ItalicSubheader from '@/components/ItalicSubheader';
import SidebarRow from '@/components/SidebarRow';

export default {
  name: 'AttributesPainterFeatures',
  components: { CardTitleRow, ItalicSubheader, SidebarRow },
  computed: {
    attributesPainterObject: sync('edit/attributesPainterObject'),
    attributesPainterObjects: get('edit/attributesPainterObjects'),
    hasAnyFeatures() {
      return this.attributesPainterObjects.length > 0;
    },
  },
  methods: {
    onHover(item, value) {
      const { layerId, id } = item;
      if (value) {
        this.$store.set('map/ADD_SELECTED_FEATURES!', {
          type: 'highlitedFeatures',
          features: {
            [layerId]: [id],
          },
        });
      } else {
        this.$store.set('map/DELETE_SELECTED_FEATURES!', {
          type: 'highlitedFeatures',
          features: {
            [layerId]: [id],
          },
        });
      }
    },
    openAttributesPainter(feature) {
      const lid = this.$route.params.lid;
      this.attributesPainterObject = feature;
      this.$router.push({ name: 'attributesPainter', params: { lid } });
    },
    zoomToFeature(id, layerId) {
      this.$root.$emit('zoomToFeature', layerId, 'layers', id);
    },
  },
};
</script>
<style lang="scss" scoped>
.v-list {
  @include border();
  .v-list-item {
    &:not(:last-child) {
      @include border(bottom);
    }
  }
}
</style>
